import React from 'react';
import PropTypes from 'prop-types';
import Icon from './Icon';
import Button from './Button';
import styled from 'styled-components';

const StyledToast = styled.div`
  width: calc(100% - 32px);
  max-width: 450px;
  border-radius: 10px;
  background-color: #333;
  box-shadow: 0 0 20px 5px rgba(0,0,0,0.15);
  height: 60px;
  padding: 0 16px;
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, ${props => props.active ? "-100px" : "100px"});
  -webkit-transition: transform .4s ease-in-out;
  -moz-transition: transform .4s ease-in-out;
  -o-transition: transform .4s ease-in-out;
  transition: transform .4s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: space-around;
  z-index: 4;
  div {
    width: auto;
    &:first-child {
      text-align: left;
      i {
        width: 20px;
        height: 20px;
        display: block;
        position: absolute;
        top: 50%;
        left: 16px;
        transform: translateY(-50%);
        svg {
          stroke: #fff;
          stroke-width: 2;
        }
      }
      span {
        color: #999;
        font-size: .825em;
        display: block;
        float: left;
        padding-left: 28px;
        @media (min-width: 640px) {
          padding-left: 10px;
        }
      }
    }
    &:last-child {
      right: 0;
      text-align: right;
      button {
        color: #999;
        background-color: transparent;
        font-size: 0.625em;
        text-transform: uppercase;
        float: right;
        -webkit-align-items: end;
        -webkit-box-align: end;
        -ms-flex-align: end;
        align-items: end;
        -webkit-box-pack: end;
        -webkit-justify-content: flex-end;
        -ms-flex-pack: end;
        justify-content: flex-end;
        margin-left: 1em;
        span {
          float: right;
          margin: 0;
        }
        &:first-child {
          color: #21A0D2;
          margin-bottom: 10px;
          @media (min-width: 480px) {
            margin-bottom: 0;
          }
        }
      }
    }
  }

`;

export default function Toast (props) {

  const {active, msg, confirm, cancel, labelConfirm, labelCancel} = props;

  return (
    <StyledToast active={active}>
      <div>
        <Icon name="checkbox"/>
        <span>{msg}</span>
      </div>
      <div>
        <Button icon="" label={labelConfirm} onClick={() => confirm()}/>
        <Button icon="" label={labelCancel} onClick={() => cancel()}/>
      </div>
    </StyledToast>)
}

Toast.defaultProps = {
  //labelConfirm: "Reduce to selection",
  labelConfirm: "Show only selected",
  labelCancel: "( - ) Deselect",
};

Toast.propTypes = {
  active: PropTypes.bool,
  confirm: PropTypes.func,
  cancel: PropTypes.func,
  msg: PropTypes.string,
  labelConfirm: PropTypes.string,
  labelCancel: PropTypes.string,
};
